export const CAROUSELMD = [
    [//this is the carousel on the island tour page, the only one as of yet
        {
            src: '/assets/images/carousel/island-tour/start-out-visitor-center.png',
            altText: 'Visitors getting into tour cars in front of the Visitor Center',
            headerStart: 'Start Your Safari ',
            headerMiddle: 'at the ',
            headerLinkSrc: '/visitor-center',
            headerLinkText: 'Visitor Center',
            paragraphText: 'Step onto our automated vehicles and start the adventure of a lifetime!'
        },
        {
            src: '/assets/images/carousel/island-tour/see-dinosaurs.png',
            altText: 'Tour cars driving past a sign that says "Dilophosaurus"',
            headerStart: 'See Your Favorite ',
            headerLinkSrc: '/dinosaurs',
            headerLinkText: 'Dinosaurs',
            headerEnd: ' Up Close',
            paragraphText: 'Witness the creatures that have made Isla Nublar famous.'
        },
        {
            src: '/assets/images/carousel/island-tour/island-tour-park-gate.png',
            altText: 'A couple of tour cars passing through the Park Gates',
            headerStart: 'Experience the Famous ',
            headerLinkSrc: 'park-gate',
            headerLinkText: 'Park Gate',
            paragraphText: 'Drive through these gigantic doors for yourself!'
        },
        {
            src: '/assets/images/carousel/island-tour/electric-fences.png',
            altText: 'Tour cars driving past a large electric fence',
            headerStart: 'Stay Safe with our Electric Fences',
            paragraphText: 'Rest assured that there is absolutely no chance of deadly catastrophe!'
        },
        {
            src: '/assets/images/carousel/island-tour/onboard-computers.png',
            altText: 'A visitor looking at an on-board computer, which shows the caption "Approaching Animal Paddocks"',
            headerStart: 'Stay Informed with ',
            headerMiddle: 'On-Board',
            headerEnd: ' Computers',
            paragraphText: 'Narrated by the award-winning Broadway frontman Richard Kiley.'
        },
        {
            src: '/assets/images/carousel/island-tour/rain.png',
            altText: 'A tour car in heavy rain',
            headerStart: 'Tour the Island No Matter ',
            headerEnd: 'the Weather',
            paragraphText: 'Our electric Ford Explorer tour vehicles are ready, rain or shine!'
        }
    ]
]